<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="12"
    >
      <v-btn
        id="btnPrint"
        class="mr-2"
        small
        dark
        :color="corPrimaria"
        :disabled="enableBtn"
        :loading="imprimindo"
        @click="exportExcel()"
      >
        <v-icon>
          mdi-printer
        </v-icon>
        Exporta Excel
        <template v-slot:loader>
          <span>Gerando...</span>
        </template>
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
  import { Array } from 'core-js'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'DashboardCoreExportExcel',
    emits: [],
    component: {},
    props: {
      headers: {
        type: Array,
        default: () => [],
      },
      table: {
        type: Array,
        default: () => [],
      },
      tituloRelatorio: {
        type: String,
        default: '',
      },
      tipoGrafico: {
        type: String,
        default: '',
      },
      textoGrafico: {
        type: String,
        default: '',
      },
      enableBtn: {
        type: Boolean,
        default: true,
      },
      dataInicial: {
        type: String,
        default: '',
      },
      dataFinal: {
        type: String,
        default: '',
      },
      arquivo: {
        type: String,
        default: '',
      },
      empresaSelect: {
        type: Array,
        default: () => [],
      },
      cidadeSelect: {
        type: Array,
        default: () => [],
      },
      vendedorSelect: {
        type: Array,
        default: () => [],
      },
      redeSelect: {
        type: Array,
        default: () => [],
      },
      areaSelect: {
        type: Array,
        default: () => [],
      },
      receita: {
        type: Array,
        default: () => [],
      },
      segmento: {
        type: Array,
        default: () => [],
      },
      produto: {
        type: Array,
        default: () => [],
      },
      linhas: {
        type: Array,
        default: () => [],
      },
      cliente: {
        type: Array,
        default: () => [],
      },
      caixa: {
        type: Array,
        default: () => [],
      },
      tabelaAgrupada: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      corPrimaria: '#2863af',
      imprimindo: false,
    }),

    watch: {
      headers: function (val) {
        this.headers = val
      },

      table: function (val) {
        this.table = val
      },

      tituloRelatorio: function (val) {
        this.tituloRelatorio = val
      },

      tipoGrafico: function (val) {
        this.tipoGrafico = val
      },

      textoGrafico: function (val) {
        this.textoGrafico = val
      },

      enableBtn: function (val) {
        this.enableBtn = val
      },

      dataInicial: function (val) {
        this.dataFinal = val
      },

      dataFinal: function (val) {
        this.dataFinal = val
      },

      empresaSelect: function (val) {
        this.empresaSelect = val
      },

      cidadeSelect: function (val) {
        this.cidadeSelect = val
      },

      vendedorSelect: function (val) {
        this.vendedorSelect = val
      },

      areaSelect: function (val) {
        this.areaSelect = val
      },

      redeSelect: function (val) {
        this.redeSelect = val
      },

      receita: function (val) {
        this.receita = val
      },

      segmento: function (val) {
        this.segmento = val
      },

      arquivo: function (val) {
        this.arquivo = val
      },

      produto: function (val) {
        this.produto = val
      },

      linhas: function (val) {
        this.linhas = val
      },

      cliente: function (val) {
        this.cliente = val
      },

      caixa: function (val) {
        this.caixa = val
      },

      tabelaAgrupada: function (val) {
        this.tabelaAgrupada = val
      },
    },

    methods: {
      async exportExcel () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet(this.tituloRelatorio)

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:F${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresaSelect.map(e => e.nome))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidadeSelect.map(e => e.cidade))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areaSelect.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redeSelect.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedorSelect.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))
            posY = adicionarFiltros(worksheet, posY, 'Produtos(s) Selecionado(s):', this.produto.map(p => p.produto))
            posY = adicionarFiltros(worksheet, posY, 'Linha(s) Selecionada(s):', this.linhas.map(l => l.linha))
            posY = adicionarFiltros(worksheet, posY, 'Cliente(s) Selecionado(s):', this.cliente.map(c => c.cliente))
            posY = adicionarFiltros(worksheet, posY, 'Caixa(s) Selecionada(s):', this.caixa.map(cx => cx.caixa))

            worksheet.addRow([])
            posY += 1

            if (this.tipoGrafico.length > 0) {
              worksheet.mergeCells(`A${posY}:F${posY}`)

              worksheet.getCell(`A${posY}`).value = 'Tipo ' + this.textoGrafico + ': ' + this.tipoGrafico
              worksheet.getCell(`A${posY}`).font = { size: 10 }
              worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }
              posY += 1

              worksheet.addRow([])
              posY += 1
            }

            posY += 1
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2
            })
          }

          inserirTitulo(worksheet)

          if (this.tabelaAgrupada) {
            this.table.forEach(cliente => {
              posY += 2
              worksheet.addRow(['Cliente: ' + cliente.cliente, 'Volume: ' + cliente.volumeExibicao]).font = { bold: true }
              posY += 1

              const headers = ['Produto', 'Última venda', 'Volume']
              worksheet.addRow(headers).font = { bold: true }
              posY += 1

              cliente.produtos.forEach(produto => {
                worksheet.addRow([produto.produto, produto.dataExibicao, produto.volumeExibicao])
                posY += 1
              })

              posY += 3

              worksheet.addRow([])
              posY += 1
            })

            // Ajustar larguras de coluna automaticamente
            worksheet.columns.forEach(column => {
              let maxLength = 0
              column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value) {
                  maxLength = Math.max(maxLength, cell.value.toString().length)
                }
              })
              column.width = maxLength + 2
            })
          } else {
            const tableHeaders = this.headers.map(header => header.text)

            const tableData = this.table.map(item =>
              Object.keys(item).map(key => item[key]),
            )

            worksheet.addRow(tableHeaders).font = { bold: true }

            tableData.forEach(row => worksheet.addRow(row))
            posY += tableData.length + 1

            ajustarLarguraColunas(worksheet, tableHeaders, tableData)
          }

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), this.arquivo)
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },
    },
  }
</script>
